import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'; // اضافه کردن Router
import './assets/fonts.css'; // اضافه کردن فایل CSS فونت
import store from './store';
import api from './services/api';
loadFonts()

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import TextPlugin from '@/plugins/textPlugin'

window.__vuetify = vuetify

const options = {
  // تنظیمات سفارشی مانند مدت زمان نمایش
  timeout: 3000,
  position: 'top-right',
};

const app = createApp(App);

app.config.globalProperties.$api = api; // اضافه کردن api به globalProperties
app.use(vuetify)
  .use(router)
  .use(store)
  .use(TextPlugin)
  .use(Toast, options)
  .mount('#app')
